<template>
<div id="main">
    <Overlay/>
    <div class="logos">
        <img src="../static/img/kurka256.png" style="width: 168px; height: 168px; padding-right: 40px;"/>
        <img src="../static/img/kurki_collective256.png" style="height: 168px;"/>
        <div class="navigation">
            <a class="navigation__link" href="http://twitter.com/kurkigames"><img src="../static/img/icons/twitter_144.png" style="width: 32px;"/></a>
            <a class="navigation__link" href="mailto:kurki.games@gmail.com"><img src="../static/img/icons/mail_144.png" style="width: 32px;"/></a>
            <a class="navigation__link" href="https://www.facebook.com/KurkiGames"><img src="../static/img/icons/facebook_144.png" style="width: 32px;"/></a>
      </div>
    </div>
    <div>
      <span class="layout-title">Hi! We are a group of Polish game developers.</span>
    </div>
    <br/>

    <HomeView/>
</div>
</template>

<script>
import HomeView from './components/HomeView.vue'
import Overlay from './components/Overlay.vue'

export default {
  components: {
    HomeView,
    Overlay
  },
  name: 'app'
}
</script>

<style>
    @import url('https://fonts.googleapis.com/css?family=Russo+One');
    
    body {
        background-color: #191919;
        color: #ddae92;
        font-family: 'Russo One', cursive;
        /*font-family: Arial, Helvetica, sans-serif;*/
    }
    
    #main {
        width: 1000px;
        margin: auto;
        text-align: center;
    }
    
    div.logos {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }
    
    .layout-title {
        font-size: 28px;
    }
    
    .navigation {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        margin-left: 50px;
        height: 168px;
    }
    
    .navigation a {
        padding-left: 10px;
        padding-right: 10px;
    }
    
    .navigation img {
        border-radius: 5px;
    }
    
    .navigation img:hover {
        transform: scale(1.2);
        cursor: pointer;
    }
    
    
    #mc_embed_signup form {text-align:center; padding:10px 0 10px 0;}
.mc-field-group { display: inline-block; } /* positions input field horizontally */
#mc_embed_signup input.email {font-size: 15px; font-family: 'Russo One', cursive; border: 1px solid #ABB0B2;  -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; color: #343434; background-color: #fff; box-sizing:border-box; height:32px; padding: 0px 0.4em; display: inline-block; margin: 0; width:300px; vertical-align:top;}
#mc_embed_signup label {display:block; font-size:20px; padding-bottom:10px; }
#mc_embed_signup .clear {display: inline-block;} /* positions button horizontally in line with input */
#mc_embed_signup .button {font-size: 13px; color: #ddae92;
        font-family: 'Russo One', cursive; border: none; -webkit-border-radius: 3px; -moz-border-radius: 3px; border-radius: 3px; letter-spacing: .03em; background-color: #444444; box-sizing:border-box; height:32px; line-height:32px; padding:0 18px; display: inline-block; margin: 0; transition: all 0.23s ease-in-out 0s;}
#mc_embed_signup .button:hover {background-color:#222222; cursor:pointer;}
#mc_embed_signup div#mce-responses {float:left; top:-1.4em; padding:0em .5em 0em .5em; overflow:hidden; width:90%;margin: 0 5%; clear: both;}
#mc_embed_signup div.response {margin:1em 0; padding:1em .5em .5em 0; font-weight:bold; float:left; top:-1.5em; z-index:1; width:80%;}
#mc_embed_signup #mce-error-response {display:none;}
#mc_embed_signup #mce-success-response {color:#529214; display:none;}
#mc_embed_signup label.error {display:block; float:none; width:auto; margin-left:1.05em; text-align:left; padding:.5em 0;}
@media (max-width: 768px) {
    #mc_embed_signup input.email {width:100%; margin-bottom:5px;}
    #mc_embed_signup .clear {display: block; width: 100% }
    #mc_embed_signup .button {width: 100%; margin:0; }
}
</style>



// WEBPACK FOOTER //
// src/App.vue